export default __webpack_public_path__ + "static/media/arbitrum.17ba9b2d.svg";